import { createUseStyles } from 'react-jss'
import { darkGray, gray, offWhite, white } from '../../../styles/colors'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: darkGray,
    padding: '25px'
  },
  footerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  footerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&:not(:first-child)': {
      marginTop: '18px'
    }
  },
  wrap: {
    flexWrap: 'wrap'
  },
  footerColumn: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileFull: {
    flexBasis: '100%'
  },
  logo: {
    width: '56px',
    marginBottom: '14px'
  },
  icon: {
    width: '16px',
    marginBottom: '15px',
    '&:not(:first-child)': {
      marginLeft: '12px'
    },
    '& > svg': {
      fill: offWhite,
      '&:hover': {
        fill: white
      },
      '&:active': {
        fill: gray
      }
    },
    cursor: 'pointer'
  },
  mainLink: {
    fontSize: '12px',
    lineHeight: '18px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    fontFamily: 'GothamRounded',
    marginBottom: '9px',
    fontWeight: 400,
    color: white,
    '&:not(:last-child)': {
      marginRight: '20px'
    },
    '&:hover': {
      color: gray
    }
  },
  secondaryLink: {
    fontSize: '8px',
    lineHeight: '12px',
    color: gray,
    fontFamily: 'GothamRounded',
    fontWeight: 400,
    textTransform: 'uppercase',
    textDecoration: 'none',
    marginTop: '6px',
    '&:not(:first-child)': {
      borderLeft: `1px solid ${gray}`,
      marginLeft: '12px',
      paddingLeft: '12px'
    },
    '&:hover': {
      color: white
    }
  },
  [MediaQueries.Tablet]: {
    footer: {
      padding: '24px 72px 16px 72px'
    },
    mobileFull: {
      flexBasis: 'auto',
      marginRight: '24px'
    },
    mainLink: {
      marginRight: '24px',
      marginBottom: '0px'
    },
    secondaryLink: {
      marginTop: '0',
      '&:not(:first-child)': {
        marginLeft: '16px',
        paddingLeft: '16px'
      }
    },
    logo: {
      marginBottom: 0
    },
    footerContent: {
      maxWidth: '690px'
    }
  },
  [MediaQueries.LaptopSmall]: {
    footer: {
      padding: '22px 80px 16px 80px'
    },
    footerContent: {
      maxWidth: '1120px'
    },
    icon: {
      width: '18px'
    }
  },
  [MediaQueries.LaptopLarge]: {
    footer: {
      padding: '22px 160px 16px 160px'
    }
  },
  [MediaQueries.Desktop]: {
    footer: {
      padding: '22px 400px 16px 400px'
    }
  }
})

export default useStyles
